import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { TaxWithholdingInterface } from '@app/interface/tax-withholding';

@Injectable({
  providedIn: 'root',
})
export class TaxWithholdingApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllTaxWithholdings<T = TaxWithholdingInterface>(
    invoice_id: number,
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/invoice/${invoice_id}/tax-withholding/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createTaxWithholding(
    invoice_id: number,
    organization_id: number | null,
    taxWithholdingData: Partial<TaxWithholdingInterface>
  ): Observable<TaxWithholdingInterface> {
    const path = `api/${organization_id}/invoice/${invoice_id}/tax-withholding/`;

    return this.post<TaxWithholdingInterface>(path, {}, taxWithholdingData);
  }

  // public updateTaxWithholdingDetails(
  //   organization_id: number | null,
  //   id: number,
  //   data: Partial<TaxWithholdingInterface>
  // ): Observable<TaxWithholdingInterface> {
  //   console.log(data);
  //   return this.partialUpdate<TaxWithholdingInterface>(
  //     `api/${organization_id}/tax-withholding/${id}/`,
  //     {}, //{ withCredentials: true },
  //     data
  //   );
  // }
}
